<template>
  <div class="dialog-overlay" @click.self="close">
    <div class="dialog-container">
      <div class="dialog-header">
        <h2>{{ isEdit ? '상담 대기 수정' : '상담 대기 등록' }}</h2>
        <button class="close-btn" @click="close">
          <i class="ph ph-x"></i>
        </button>
      </div>

      <div class="dialog-body">
        <div class="form-group">
          <label>이름 <span class="required">*</span></label>
          <input type="text" v-model="form.name" placeholder="고객 이름" />
        </div>

        <div class="form-group">
          <label>연락처</label>
          <input type="tel" v-model="form.phone" placeholder="010-0000-0000" />
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>등급</label>
            <select v-model="form.grade">
              <option value="신규">신규</option>
              <option value="일반">일반</option>
              <option value="VIP">VIP</option>
              <option value="VVIP">VVIP</option>
            </select>
          </div>

          <div class="form-group">
            <label>상담 유형</label>
            <select v-model="form.consult_type">
              <option value="신규상담">신규상담</option>
              <option value="보험가입">보험가입</option>
              <option value="보험청구">보험청구</option>
              <option value="계약변경">계약변경</option>
              <option value="해지문의">해지문의</option>
              <option value="기타문의">기타문의</option>
            </select>
          </div>
        </div>

        <div class="form-group" v-if="isEdit">
          <label>상태</label>
          <select v-model="form.status">
            <option :value="0">대기중</option>
            <option :value="1">상담중</option>
            <option :value="2">완료</option>
            <option :value="3">취소</option>
          </select>
        </div>

        <div class="form-group">
          <label>메모</label>
          <textarea v-model="form.memo" placeholder="요청사항이나 메모를 입력하세요" rows="3"></textarea>
        </div>

        <div class="info-box" v-if="isEdit && form.picked_by">
          <p><strong>담당자:</strong> {{ form.picked_by }}</p>
          <p><strong>배정시간:</strong> {{ form.picked_at }}</p>
        </div>
      </div>

      <div class="dialog-footer">
        <button v-if="isEdit" class="btn-delete" @click="handleDelete">삭제</button>
        <div class="footer-right">
          <button class="btn-cancel" @click="close">취소</button>
          <button class="btn-save" @click="handleSave" :disabled="!form.name">저장</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref, computed, onMounted } from 'vue';

export default {
  props: {
    item: {
      type: Object,
      default: null
    },
    onClose: {
      type: Function,
      required: true
    },
    onSaved: {
      type: Function,
      default: () => {}
    }
  },
  setup(props) {
    const sql_query = inject('sql_query');

    const isEdit = computed(() => !!props.item?.idx);

    const form = ref({
      idx: null,
      name: '',
      phone: '',
      grade: '신규',
      consult_type: '신규상담',
      memo: '',
      status: 0,
      picked_by: null,
      picked_at: null
    });

    onMounted(() => {
      if (props.item) {
        form.value = { ...props.item };
      }
    });

    function close() {
      props.onClose();
    }

    async function handleSave() {
      if (!form.value.name) {
        alert('이름을 입력해주세요.');
        return;
      }

      try {
        if (isEdit.value) {
          // 수정
          await sql_query(`
            UPDATE consult_waiting SET
              name = '${form.value.name}',
              phone = '${form.value.phone || ''}',
              grade = '${form.value.grade}',
              consult_type = '${form.value.consult_type}',
              memo = '${(form.value.memo || '').replace(/'/g, "''")}',
              status = ${form.value.status}
            WHERE idx = ${form.value.idx}
          `);
        } else {
          // 신규 등록
          await sql_query(`
            INSERT INTO consult_waiting (name, phone, grade, consult_type, memo, status)
            VALUES (
              '${form.value.name}',
              '${form.value.phone || ''}',
              '${form.value.grade}',
              '${form.value.consult_type}',
              '${(form.value.memo || '').replace(/'/g, "''")}',
              0
            )
          `);
        }
        props.onSaved();
        close();
      } catch (e) {
        console.error(e);
        alert('저장에 실패했습니다.');
      }
    }

    async function handleDelete() {
      if (!confirm('정말 삭제하시겠습니까?')) return;

      try {
        await sql_query(`DELETE FROM consult_waiting WHERE idx = ${form.value.idx}`);
        props.onSaved();
        close();
      } catch (e) {
        console.error(e);
        alert('삭제에 실패했습니다.');
      }
    }

    return {
      form,
      isEdit,
      close,
      handleSave,
      handleDelete
    };
  }
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.dialog-container {
  background: var(--color-background);
  border-radius: 16px;
  width: 90%;
  max-width: 480px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--color-border);
}

.dialog-header h2 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--color-text);
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-body {
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text);
}

.form-group label .required {
  color: #ff4444;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--color-surface-reverse);
  background: var(--color-background);
  font-size: 14px;
  color: var(--color-text);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-brand);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.form-row {
  display: flex;
  gap: 12px;
}

.form-row .form-group {
  flex: 1;
}

.info-box {
  background: var(--color-background);
  border-radius: 8px;
  padding: 12px;
}

.info-box p {
  margin: 0;
  font-size: 13px;
  color: var(--color-text-muted);
}

.info-box p + p {
  margin-top: 4px;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid var(--color-border);
  gap: 12px;
}

.footer-right {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.btn-cancel,
.btn-save,
.btn-delete {
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel {
  background: var(--color-background);
  color: var(--color-text);
}

.btn-save {
  background: var(--color-brand);
  color: #fff;
}

.btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-delete {
  background: #ff4444;
  color: #fff;
}

.btn-cancel:hover {
  background: var(--color-border);
}

.btn-save:hover:not(:disabled) {
  opacity: 0.9;
}

.btn-delete:hover {
  background: #cc3333;
}
</style>